import Vue from 'vue'
import router from 'vue-router'
import Login from '@/components/Login'
import Homepage from '@/components/Homepage'
import Photo from '@/components/Photo'
import Successful from '@/components/Successful'
import UserInfoCommit_HomeAndWork from '@/components/UserInfoCommit_HomeAndWork'
import VehicleInformation from '@/components/VehicleInformation'
import OneGuide from '@/components/OneGuide'
import Lx_CollectData from '@/components/Lx-CollectData'
import Lx_Success from '@/components/Lx-Success'
import Vcar_List from '@/components/Vcar_List'
import Vcar_Collect from '@/components/Vcar_Collect'
import Vcar_Result from '@/components/Vcar_Result'
import Vcar_Login from '@/components/Vcar_Login'
import Vcar_PersonalInformation from '@/components/Vcar_PersonalInformation'
import Aions_Mar from '@/components/Promotion/Aions_Mar'
import Aions_Mar_Detail from '@/components/Promotion/Aions_Mar_Detail'
import Aions_GZ_Mar from '@/components/Promotion/Aions_GZ_Mar'
import TslPro from '@/components/Promotion/Zuzuche_Pro'
import Zuzuche from '@/components/Promotion/Zuzuche'
import Success from '@/components/Promotion/Success'
import LoginUpload from '@/components/Upload/LoginUpload'
import SearchResult from '@/components/Upload/searchResult'
import UploadImage from '@/components/Upload/UploadImage'
import Cus_Login from '@/components/CustomersInfo/Cus_Login';
import Cus_Collect from '@/components/CustomersInfo/Cus_Collect';
import Cus_Success from '@/components/CustomersInfo/Cus_CollectSuccess';
import VcarCalculator from '@/components/VcarCalculator';
import CusCollectP7 from '@/components/CustomersInfo/Cus_Collect_P7';
import CusCollectP7Success from '@/components/CustomersInfo/Cus_Collect_P7_Success';
import Partner from '@/components/partner';
import Nio from '@/components/WeiLai/WeiLai';
import Nio_Success from '@/components/WeiLai/WeiLaiSuccess';
import Quick_Sales_Info from '@/components/QuickSales/QuickSalesInfo';
import Quick_Sales from '@/components/QuickSales/QuickSales';

Vue.use(router)

export default new router({
  routes: [
    {
      path: '/quick_sales_info',
      name: 'quick_sales_info',
      component: Quick_Sales_Info,
      meta: {
        title: '车家·Quick Sales',
      }
    },
    {
      path: '/quick_sales',
      name: 'quick_sales',
      component: Quick_Sales,
      meta: {
        title: '车家·Quick Sales',
      }
    },


    {
      path: '/',
      name: 'Cus_Login',
      component: Cus_Login,
      meta: {
        title: '车家-资料上传助手',
        // code: 8
      }
    },
    {
      path: '/nio',
      name: 'nio',
      component: Nio,
      meta: {
        title: '蔚来汽车限时劲爆促销',
        code: 11
      }
    },
    {
      path: '/nio_success',
      name: 'Nio_Success',
      component: Nio_Success,
      meta: {
        title: '蔚来汽车限时劲爆促销',
        code: 11
      }
    },
    {
      path: '/partner',
      name: 'partner',
      component: Partner,
      meta: {
        title: '车家'
      }
    },
    {
      path: '/cus_collect',
      name: 'Cus_Collect',
      component: Cus_Collect,
      meta: {
        title: '车家-资料上传助手',
        // code: 8
      }
    },
    {
      path: '/cus_success',
      name: 'Cus_Success',
      component: Cus_Success,
      meta: {
        title: '车家-资料上传助手',
        code: 8
      }
    },
    {
      path: '/successful',
      name: 'Successful',
      component: Successful,
      meta: {
        title: '车家'
      }
    },
    {
      path: '/vehicleInformation',
      name: 'VehicleInformation',
      component: VehicleInformation,
      meta: {
        title: '车家'
      }
    },
    // {
    //   path: '/simple',
    //   name: 'guide',
    //   component: OneGuide,
    //   meta: {
    //     title: '车家'
    //   }
    // },
    {
      path: '/applyLxOne',
      name: 'Lx_CollectData',
      component: Lx_CollectData,
      meta: {
        title: '江南银行'
      }
    },
    {
      path: '/applyLxOne_Success',
      name: 'Lx_Success',
      component: Lx_Success,
      meta: {
        title: '江南银行'
      }
    },
    {
      path: '/vcar_login',
      name: 'Vcar_Login',
      component: Vcar_Login,
      meta: {
        title: '车家·寻车',
        code: 4
      }
    },
    {
      path: '/vcar_list',
      name: 'Vcar_List',
      component: Vcar_List,
      meta: {
        title: '车家·寻车',
        code: 4
      }
    },
    {
      path: '/vcar_result',
      name: 'Vcar_Result',
      component: Vcar_Result,
      meta: {
        title: '车家·寻车',
        code: 4
      }
    },
    {
      path: '/vcar_personalinformation',
      name: 'Vcar_PersonalInformation',
      component: Vcar_PersonalInformation,
      meta: {
        title: '车家·寻车',
        code: 4
      }
    },
    {
      path: '/vcar_collect',
      name: 'Vcar_Collect',
      component: Vcar_Collect,
      meta: {
        title: '车家·寻车',
        code: 4
      }
    },
    // {
    //   path: '/aions_mar',
    //   name: 'Aions_Mar',
    //   component: Aions_Mar
    // },
    // {
    //   path: '/aions_mar_detail',
    //   name: 'Aions_Mar_Detail',
    //   component: Aions_Mar_Detail
    // },
    // {
    //   path: '/aions_gz_mar',
    //   name: 'Aions_GZ_Mar',
    //   component: Aions_GZ_Mar
    // },
    // {
    //   path: '/tsl_pro',
    //   name: 'TslPro',
    //   component: TslPro
    // },
    // {
    //   path: '/zzc',
    //   name: 'Zuzuche',
    //   component: Zuzuche
    // },
    // {
    //   path: '/success',
    //   name: 'Success',
    //   component: Success
    // },
    {
      path: '/upload_login',
      name: 'LoginUpload',
      component: LoginUpload,
      meta: {
        title: '车家',
        code: 10
      }
    },
    {
      path: '/result',
      name: 'SearchResult',
      component: SearchResult,
      meta: {
        title: '车家',
        code: 10
      }
    },
    {
      path: '/upload',
      name: 'Upload',
      component: UploadImage,
      meta: {
        title: '车家',
        code: 10
      }
    },
    {
      path: '/lxcheck',
      // redirect: '/service/insurance'
      component: () => import('@/components/SimpleDelivery'),
      meta: {
        title: '车家check 理想专用',
        code: 9
      }
    },
    {
      path: '/simple-orders',
      name: 'orderList',
      component: () => import('@/components/SimpleDelivery/OrderList/index'),
      meta: {
        title: '我的理想客户',
        code: 9
      }
    },
    {
      path: '/financial',
      name: 'financial',
      component: () => import('@/components/SimpleDelivery/Financial/index'),
      meta: {
        code: 9
      }
    },
    {
      path: '/vcar_calculator',
      name: 'VcarCalculator',
      component: VcarCalculator,
      meta: {
        title: '车家'
      }
    },
    {
      path: '/cus_collect_p7',
      name: 'CusCollectP7',
      component: CusCollectP7,
      meta: {
        title: '车家',
        code: 3
      }
    },
    {
      path: '/cus_collect_p7_success',
      name: 'CusCollectP7Success',
      component: CusCollectP7Success,
      meta: {
        title: '车家',
        code: 3
      }
    },
    // {
    //   path: '/xp01',
    //   name: 'xp2108',
    //   component: () => import('@/components/Promotion/xp2108/xp2108'),
    //   meta: {
    //     title: '小鹏P7限时劲爆促销'
    //   }
    // },
    // {
    //   path: '/xp01_success',
    //   name: 'xp08_success',
    //   component: () => import('@/components/Promotion/xp2108/success'),
    //   meta: {
    //     title: '小鹏P7限时劲爆促销'
    //   }
    // },

    {
      path: '/shPreApprove',
      name: 'shPreApprove',
      component: ()=> import('@/components/ShPreApprove/preApprove.vue'),
      meta: {
        title: '理想汽车 上海银行'
      }
    },
    {
      path: '/shPreApprove_result',
      name: 'preApproveResult',
      component: ()=> import('@/components/ShPreApprove/preApproveResult.vue'),
      meta: {
        title: '理想汽车 上海银行'
      }
    },
    {
      path: '/jnAgreeList',
      name: 'JnAgreeList',
      component: ()=> import('@/components/JnBankLoan/JnAgreeList.vue')
    },
    {
      path: '/agree',
      name: 'agreeList',
      component: ()=> import('@/components/ShPreApprove/agreeListPage.vue')
    },
    {
      path: '/pdf',
      name: 'pdfComponents',
      component: ()=> import('@/components/ShPreApprove/pdf.vue'),
    },
    {
      path: '/xp2110',
      name: 'xp2110',
      component: ()=> import('@/components/Promotion/xp2110/xp2110.vue'),
      meta: {
        title: '车家',
        code: 12
      }
    },
    {
      path: '/xp2110_success',
      name: 'xp2110_success',
      component: ()=> import('@/components/Promotion/xp2110/success.vue'),
      meta: {
        title: '车家',
        code: 12
      }
    }, 
    {
      path: '/lxApplyLoan',
      name: 'jnbankLoan',
      component: ()=> import('@/components/JnBankLoan/index.vue'),
      meta: {
        title: '江南银行 理想汽车车贷申请'
      }
    },
    {
      path: '/lxApplyLoanResult',
      name: 'jnbankLoanResult',
      component: ()=> import('@/components/JnBankLoan/result.vue'),
      meta: {
        title: '江南银行 理想汽车车贷申请'
      }
    },
    {
      path: '/lxApply',
      name: 'jnbankLoanDeclarat',
      component: ()=> import('@/components/JnBankLoan/Declarat.vue'),
      meta: {
        title: '理想汽车车贷申请',
        code: 13
      }
    },
    {
      path: '/lxApplyLoanForm',
      name: 'jnbankLoanForm',
      component: ()=> import('@/components/JnBankLoan/Form.vue'),
      meta: {
        title: '江南银行 理想汽车车贷申请'
      }
    },
    {
      path: '/lxApplyLoanQRCode',
      name: 'jnbankLoanQRCode',
      component: ()=> import('@/components/JnBankLoan/QRcodeAndDownload.vue'),
      meta: {
        title: '江南银行 理想汽车车贷申请'
      }
    },
    {
      path: '/car_life',
      name: 'CarLife',
      component: ()=> import('@/components/CarLife/index.vue'),
      meta: {
        title: '灿谷车分期进度查询'
      }
    }
  ]

})



// WEBPACK FOOTER //
// ./src/router/index.js